import type { SVGProps } from 'react';

export function CompanyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M4.46733 12.5007H2.76733C1.814 12.5007 1.33398 12.0206 1.33398 11.0673V3.26733C1.33398 2.314 1.814 1.83398 2.76733 1.83398H5.63399C6.58733 1.83398 7.0673 2.314 7.0673 3.26733V4.50065'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.5801 6.11332V13.5533C11.5801 14.6267 11.0468 15.1667 9.97347 15.1667H6.08012C5.00679 15.1667 4.4668 14.6267 4.4668 13.5533V6.11332C4.4668 5.03999 5.00679 4.5 6.08012 4.5H9.97347C11.0468 4.5 11.5801 5.03999 11.5801 6.11332Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.93359 4.50065V3.26733C8.93359 2.314 9.41357 1.83398 10.3669 1.83398H13.2336C14.1869 1.83398 14.6669 2.314 14.6669 3.26733V11.0673C14.6669 12.0206 14.1869 12.5007 13.2336 12.5007H11.5802'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.66602 7.83398H9.33268'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.66602 9.83398H9.33268'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8 15.166V13.166'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
